module.exports = __webpack_public_path__ + "img/bnr1.34279ce8.png";